import { indexData } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-600',
  primary: 'bg-primary-100 text-primary-600',
  secondary: 'bg-secondary-100 text-secondary-600',
};

const borderColorMap: Record<string, string> = {
  accent: 'hover:border-accent-300',
  primary: 'hover:border-primary-300',
  secondary: 'hover:border-secondary-300',
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            按类型探索你最爱的影视内容
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexData.slice(0, 4).map((item, idx) => (
              <a
                key={idx}
                href={`#${item.title}`}
                className={`group block p-5 md:p-6 rounded-xl bg-background-100 border border-background-200 hover:shadow-sm transition-all duration-200 cursor-pointer ${borderColorMap[item.color] || 'hover:border-primary-300'}`}
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${colorMap[item.color] || colorMap.primary}`}>
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-medium text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </a>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
            {indexData.slice(4, 7).map((item, idx) => (
              <a
                key={idx + 4}
                href={`#${item.title}`}
                className={`group block p-5 md:p-6 rounded-xl bg-background-100 border border-background-200 hover:shadow-sm transition-all duration-200 cursor-pointer ${borderColorMap[item.color] || 'hover:border-primary-300'}`}
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${colorMap[item.color] || colorMap.primary}`}>
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-medium text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}